import React, { FC, useState, FormEvent, Fragment } from 'react'
import { Button } from 'components/Button'
// import { Calendar } from 'components/Calendar'
import { TextInput } from 'components/TextInput'
import { Icon } from 'components/Icon'
import { Confirmation } from '../shared/Confirmation'
import { Dialog } from 'components/Dialog'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { Stack } from 'components/Stack'
import styles from './MobilityReportWizard.module.scss'
import { useMapEditorContext } from 'context/map-editor-context'
import { useFetchOrganization } from 'services/organization'
import { useUserContext } from 'context/user-context'
import { useParams } from 'react-router-dom'
import { Flex } from 'components/Flex'
import { Spinner } from 'components/Spinner'
import { PointCoordinates } from 'models/map'
import { coordinatesToLngLat } from 'utils/coordinates'
import { StorageProvider } from 'providers/storage'
import { Alert } from 'components/Alert'

declare global {
  interface Date {
    addDays(days: number, useThis?: boolean): Date
    subDays(days: number, useThis?: boolean): Date
  }
}

// eslint-disable-next-line
Date.prototype.addDays = function (days: number): Date {
  const date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)

  return date
}

// eslint-disable-next-line
Date.prototype.subDays = function (days: number): Date {
  const date = new Date(this.valueOf())
  date.setDate(date.getDate() - days)

  return date
}

type Steps = 'confirm' | 'download' | 'loading' | 'ready'

export const MobilityReportWizard: FC = () => {
  const { t } = useTranslation()
  const { projectId } = useParams()
  const [currentUser] = useUserContext()
  const { organization, status: orgStatus } = useFetchOrganization()
  const [{ confirmed, editor }, mapEditorDispatch] = useMapEditorContext()
  const [step, setStep] = useState<Steps>('confirm')
  const coordinates = editor.feature?.geometry?.coordinates as PointCoordinates
  const [reportName, setReportName] = useState<string | undefined>(undefined)
  // const today = new Date()
  // const [startDate, setStartDate] = useState<Date>(today.subDays(8))
  // const [endDate, setEndDate] = useState<any>(startDate.addDays(1))

  const [noReportName, setNoReportName] = useState<boolean>(false)

  /*const excludedDates = [
    startDate.addDays(1),
    startDate.addDays(2),
    startDate.addDays(3),
    startDate.addDays(4),
    startDate.addDays(5),
    today,
    today.subDays(1),
    today.subDays(2),
    today.subDays(3),
    today.subDays(4),
    today.subDays(5),
  ]*/

  /*const onDateChange = (dates: any) => {
    const [start, end] = dates

    setStartDate(start)
    setEndDate(end)
  }*/

  const onDialogClose = () => {
    mapEditorDispatch.cancelWizard()
  }

  const onSubmit = (event: FormEvent) => {
    var orgid = organization?.id

    const staticStartDate =
      'Tue%20Aug%2001%202023%2000:00:00%20GMT-0600%20(Central%20Standard%20Time)'
    const staticEndDate =
      'Thu%20Aug%2031%202023%2000:00:00%20GMT-0600%20(Central%20Standard%20Time)'

    if (!reportName) {
      setNoReportName(true)

      setTimeout(() => {
        setNoReportName(false)
      }, 5000)
    } else {
      const reportRequestData = {
        ...coordinatesToLngLat(coordinates),
        projectId,
        orgid,
        startDate: staticStartDate,
        endDate: staticEndDate,
      }

      getReportData(reportRequestData)
    }
  }

  const getReportData = async (reportRequestData: any) => {
    setStep('loading')
    var namereporte = /*valor*/ reportName
    var projectid3 = 'mob'
    var userid = currentUser?.id
    var language = StorageProvider.get('language')

    const staticStartDate =
      'Tue%20Aug%2001%202023%2000:00:00%20GMT-0600%20(Central%20Standard%20Time)'
    const staticEndDate =
      'Thu%20Aug%2031%202023%2000:00:00%20GMT-0600%20(Central%20Standard%20Time)'

    var url2 =
      'https://report.descifra.global/GetReports.ashx?idorg=' +
      reportRequestData.orgid +
      '&lat=' +
      reportRequestData.lat +
      '&lng=' +
      reportRequestData.lng +
      '&nombre=' +
      namereporte +
      '&Key=RGVzY2lmcmEwOTIz&correo=' +
      String(currentUser!.email) +
      '&type=mobility&mr=' +
      String(organization!.mobilityReport) +
      '&pr=' +
      String(organization!.predictiveReport) +
      '&projectid=' +
      String(projectid3) +
      '&userid=' +
      String(userid) +
      '&fechaini=' +
      staticStartDate +
      // reportRequestData.startDate +
      '&fechafin=' +
      staticEndDate +
      // reportRequestData.endDate +
      '&language=' +
      language
    const data = await fetch(url2)
    const resp = await data.json()

    if (resp[0].status === '200') {
      setStep('ready')
    } else {
      alert('Error en la generación del reporte, contacta a soporte.')
    }
  }

  const SaveRegFreemium = async () => {
    var url3 =
      'https://report.descifra.global/CallApi.ashx?idorg=' +
      String(organization?.id) +
      '&Key=RGVzY2lmcmEwOTIz&type=mobility&userid=' +
      String(currentUser?.id)
    const data = await fetch(url3)
    const resp = await data.json()

    if (resp[0].status === '200') {
      setStep('ready')
    } else {
      alert('Error en la generación del reporte, contacta a soporte.')
    }
  }

  var flagFreemium = false
  if (organization?.subscription.level === 'Freemium') {
    flagFreemium = true
  }

  if (!organization || orgStatus === 'loading') return null
  if (confirmed) {
    return (
      <Dialog
        isOpen={confirmed}
        onClose={onDialogClose}
        aria-label={t(`mobility_report_dialog.${step}.title`)}
        className={styles.mobilityReportDialog}
      >
        <Stack>
          <div className={styles.icono1}>
            <Icon className={styles.icono} name="base-station-line" size="xl" />
            <Heading className={styles.icono2}>{t(`mobility_report_dialog.${step}.title`)}</Heading>
          </div>
          {step === 'confirm' && flagFreemium === false && (
            <Fragment>
              <br />
              <Heading size="widget">{t(`mobility_report_dialog.creation.step_one`)}</Heading>{' '}
              <br />
              <TextInput
                name="reportName"
                label={t(`mobility_report_dialog.creation.step_one_placeholder`)}
                value={reportName}
                onChange={(event) => setReportName(event.target.value)}
              />
              {/*<br />
              <Heading size="widget">{t(`mobility_report_dialog.creation.step_two`)}</Heading>
              <br />
              <div className={styles.icono1}>
                <Icon className={styles.iconMargin} name="error-warning-line" />

                <Text>{t(`mobility_report_dialog.creation.step_two_advice`)}</Text>
              </div>
              <br />
              <Calendar
                startDate={startDate}
                endDate={endDate}
                monthsShown={2}
                onChange={onDateChange}
                excludeDates={excludedDates}
                maxDate={startDate.addDays(30)}
                excludeDateIntervals={[
                  { start: new Date(today), end: new Date(today.addDays(60)) },
                ]}
              />*/}
              <br />
              {noReportName && (
                <Fragment>
                  <Alert tone="critical" full>
                    Es necesario asignar un nombre al reporte.
                  </Alert>
                  <br />
                  <br />
                </Fragment>
              )}
              <Button full onClick={onSubmit}>
                {t(`mobility_report_dialog.creation.action_button`)}
              </Button>
            </Fragment>
          )}
          {step === 'confirm' && flagFreemium === true && (
            <div>
              <Text>{t(`mobility_report_dialog.${step}.cta`)}</Text>
              <br></br>
              <input
                className={styles.textInput}
                id="reportName"
                type="text"
                name="nombre"
                onChange={(event) => setReportName(event.target.value)}
                placeholder="Nombre del reporte"
              />
              <br></br>
              <br></br>
              <a
                href="https://report.descifra.global/PlantillasReportes/DescifraMovilidad_Muestra.pdf"
                className={styles.downloadLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={SaveRegFreemium}
              >
                <button className={styles.buttonDownload}>Generar Reporte</button>{' '}
              </a>
            </div>
          )}
          {step === 'loading' && (
            <div>
              <Text>{t(`mobility_report_dialog.${step}.cta`)}</Text>
              <br></br>
              <Flex justify="center" align="center">
                <Spinner />
              </Flex>
            </div>
          )}
          {step === 'ready' && (
            <div>
              <div className={styles.icono1}>
                <Icon className={styles.transparentIcon} name="mail-send-line" size="xl" />
                <Text className={styles.icono2}>{t(`mobility_report_dialog.${step}.cta`)}</Text>
              </div>
              <br />
              <div className={styles.icono1}>
                <Icon className={styles.icono3} name="mail-send-line" size="xl" />
                <Text className={styles.icono2}>{t(`mobility_report_dialog.${step}.desc`)}</Text>
              </div>
            </div>
          )}
        </Stack>
      </Dialog>
    )
  }
  return <Confirmation onConfirm={() => mapEditorDispatch.setConfirm(true)} />
}

MobilityReportWizard.displayName = 'MobilityReportWizard'
